module.exports = __webpack_public_path__ + "static/media/HNTFILBookCover.4e114cd7.jpg";